import { Component, Input } from '@angular/core';
import { cn } from '../../utils/cn';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-bimbo-spinner',
  imports: [TranslatePipe],
  templateUrl: './bimbo-spinner.html',
  styleUrl: './bimbo-spinner.css',
})
export class BimboSpinner {
  @Input() loadingText: string = '';
  @Input() translate = false;

  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  @Input() fullscreen = false;

  @Input() class = '';
  @Input() textClass = '';

  get containerClasses() {
    return cn(
      'flex flex-col items-center justify-center gap-2',
      this.fullscreen && 'h-screen w-full',
      this.class,
    );
  }

  get spinnerClasses() {
    return cn({
      'spinner-sm': this.size === 'sm',
      'spinner-md': this.size === 'md',
      'spinner-lg': this.size === 'lg',
    });
  }

  get textClasses() {
    return cn('text-slate-600 text-sm', this.textClass);
  }
}
